export const theme = {
    primary: "#0078AE",
    secondary: "#70CDE3",
    white: "#ffffff",
    text: "#282828",
    text_grey: "rgba(0,0,0,0.25)",
    grey_light: "#e0e0e0"
};
